export default "/images/wechat.svg?390bf08b6bf6ade2ae87453a1a208c47";